import React from "react"
import FeaturedPost from "./FeaturedPost"

function BlogByPost({ data, pageContext }) {
  const { previousPagePath } = pageContext

  return (
    <>
      {!previousPagePath && (
        <>
          {/*  Page header */}
          <div className="max-w-3xl pb-12 md:pb-20 text-center md:text-left">
            <h1 className="h1" data-aos="fade-up">
              Filmustage Blog
            </h1>
          </div>

          <FeaturedPost {...data.featuredPost} />

          {/*  Section line */}
          <div
            className="pb-4 mb-10 border-b border-gray-700"
            data-aos="fade-up"
          />
        </>
      )}

      {previousPagePath && (
        <div
          className="max-w-3xl mx-auto text-center pb-12 md:pb-16"
          data-aos-id-blog
        >
          <h1
            className="h2 mb-4 capitalize"
            data-aos="fade-up"
            data-aos-anchor="[data-aos-id-blog]"
          >
            Filmustage Blog
          </h1>
        </div>
      )}
    </>
  )
}

export default BlogByPost
